import { useSyncExternalStore } from 'react';
import { createSponsorStore } from './store-core';
import { createBrowserSponsorStorage } from './storage';
import type { AdStatus, OrderStatus, SponsorState } from './types';

export type { AccountStatus, AdStatus, OrderStatus, SponsorAccount, SponsorAd, SponsorOrder, SponsorPayment, SponsorNotice, SponsorState, RegisterInput, PlaceOrderInput } from './types';

const sponsorStore = createSponsorStore({ storage: createBrowserSponsorStorage() });

export function useSponsorStore(): SponsorState {
  return useSyncExternalStore(sponsorStore.subscribe, sponsorStore.getSnapshot, sponsorStore.getSnapshot);
}

export const getSponsorState = sponsorStore.getSnapshot;
export const {
  registerAccount, signOut, placeOrder, resubmitAd, buyPoints,
  confirmTransfer, approveOrder, requestChanges, rejectAccount, endOrder, resetSponsorDemo,
} = sponsorStore;

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  waiting_payment: 'Waiting for payment',
  in_review: 'OPS checking',
  needs_changes: 'Needs changes',
  live: 'Live',
  ended: 'Ended',
};

export const AD_STATUS_LABEL: Record<AdStatus, string> = {
  checking: 'OPS checking',
  needs_changes: 'Needs changes',
  live: 'Live',
  scheduled: 'Scheduled',
  ended: 'Ended',
};
